<script setup lang="ts">
// AppLayout's `.page-content` already provides the page gutter (1.5rem),
// so the page wrapper renders content edge-to-edge — no inner padding.
import AdminsContainer from './containers/AdminsContainer.vue'
</script>

<template>
  <AdminsContainer />
</template>
